(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-b2b"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var f = document.getElementById('csB2bForm');
    if (!f) return;
    var msg = document.getElementById('csB2bMsg');
    var lang = (document.documentElement.lang || 'it').indexOf('en') === 0 ? 'en' : 'it';
    var doc = f.dataset.documento + (f.dataset.documento.indexOf('?') > -1 ? '&' : '?') + 'lang=' + lang;
    var ATTESA = lang === 'en' ? 'One moment...' : 'Un attimo...';
    var ERRORE = lang === 'en'
      ? 'Something went wrong, please try again or write to lagenovese@coffeestorming.it'
      : 'Qualcosa non ha funzionato, riprova o scrivici a lagenovese@coffeestorming.it';
    var ERRMAIL = lang === 'en'
      ? 'That email domain does not accept mail. Please check the address.'
      : "Quel dominio email non riceve posta. Controlla l'indirizzo.";

    f.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!f.checkValidity()) { f.reportValidity(); return; }
      var btn = f.querySelector('button[type=submit]');
      btn.disabled = true;
      msg.textContent = ATTESA;
      var d = { lingua: lang };
      ['nome', 'cognome', 'locale', 'consumo', 'telefono', 'email', 'website'].forEach(function (k) {
        var el = f.querySelector('[name=' + k + ']');
        d[k] = el ? el.value : '';
      });
      ['consenso_privacy', 'consenso_marketing'].forEach(function (k) {
        var el = f.querySelector('[name=' + k + ']');
        d[k] = el ? el.checked : false;
      });
      fetch(f.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(d)
      })
        .then(function (r) { return r.json().then(function (j) { return { stato: r.status, dati: j }; }); })
        .then(function (res) {
          if (res.dati && res.dati.ok) { window.location.href = doc; return; }
          msg.textContent = res.stato === 422 ? ERRMAIL : ERRORE;
          if (res.stato === 422) {
            var em = f.querySelector('[name=email]');
            if (em) { em.focus(); em.select(); }
          }
          btn.disabled = false;
        })
        .catch(function () { msg.textContent = ERRORE; btn.disabled = false; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-stay-local"]) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      if (root.getAttribute('data-ready') || !('IntersectionObserver' in window)) return;
      root.setAttribute('data-ready', '1');

      /* reveal on scroll: skipped with reduced motion, and the class is-js is what hides the elements */
      if (!reduce) {
        root.classList.add('is-js');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
        root.querySelectorAll('[data-r]').forEach(function (el) { io.observe(el); });
      }

      /* sticky button: on once the hero button has gone up, off while another button is on screen
         and once the closing button has been passed */
      var bar = root.querySelector('[data-sticky]');
      var ctas = root.querySelectorAll('[data-cta]');
      if (!bar || !ctas.length) return;
      var state = {};
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var k = e.target.getAttribute('data-cta');
          state[k] = e.isIntersecting ? 'in' : (e.boundingClientRect.top < 0 ? 'above' : 'below');
        });
        var seen = Object.keys(state).some(function (k) { return state[k] === 'in'; });
        bar.classList.toggle('is-on', !seen && state.hero === 'above' && state.close !== 'above');
      }, { threshold: 0.6 });
      ctas.forEach(function (el) { cio.observe(el); });
    }

    function boot() { document.querySelectorAll('.cs-sl').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
